import React from 'react';
import styles from './Header.module.css';
import { Col, Row } from "react-bootstrap";
import { resetAuthData } from './../../../redux/reducers/auth-reducer';
import { connect } from 'react-redux';
import { useEffect } from 'react';


const Header = ({ resetAuthData, isAuth }) => {

  const logOut = () => resetAuthData()

  
  return (
    <div className={styles.container}>
      <div className="container">
        <Row noGutters className='row justify-content-md-center'>
          <Col className={styles.backgroundImage}>
            <Row noGutters>
              <Col className={styles.ministrySection}>
                <div className={styles.ministry}>
                  Департамент военного образования
                  Министерства обороны Российской Федерации
                </div>
                <div className={styles.library}>
                  <div>Система рейтинговой оценки</div>
                  <div className={styles.subHeader}>довузовских общеобразовательных организаций <br/>Минобороны России</div>
                {isAuth ?
                  <div>
                    <span
                    onClick={logOut}
                    className={styles.logout}
                  >
                    выход
                  </span>
                  <span>
                    {localStorage.getItem('fio')||isAuth.FIO}
                  </span>
                  </div>
                  : null}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Header

